export class LocationHome {
  showFindUs: boolean;
  alternateButtonLinks: boolean;
  headerType: string = 'none'; // video or slider
  tabBoxViewRatesButtonText: string;
  tabBoxPayBillButtonText: string;
  tabBoxViewRatesButtonAltLink: string;
  tabBoxPayBillButtonAltLink: string;
  subtractFromFullHeight?: number;

  constructor() {
    this.showFindUs = true;
    this.headerType = 'none';
    this.tabBoxViewRatesButtonText = 'View Rates';
    this.tabBoxPayBillButtonText = 'Pay Bill';
    this.tabBoxViewRatesButtonAltLink = 'units';
    this.tabBoxPayBillButtonAltLink = 'customer-portal/login';
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/location-home.ts